import { Hashtag } from "./hashtag";

/**
 * Hashtag per widget info
 */
export class HashtagPerWidget {
  /**
   * Hashtag
   */
  hashtag: Hashtag;

  /**
   * Widget ID
   */
  widgetId: number;
}

/**
 * Hashtags per widget info
 */
export class HashtagsPerWidget {
  /**
   * List of hashtags
   */
  hashtag: Hashtag[];

  /**
   * Widget ID
   */
  widgetId: number;
}
